<template>
  <div class="LKMunMehCard">
    <LKMunMehCardHeader
      :id="data.id"
      :value="true"
      :date="data.created_at"
      actionless
    />

    <div
      class="LKMunMehCard__content is-title"
      v-text="data.name"
    />

    <LKMunMehCardForm
      :data="data"
    />
  </div>
</template>

<script>
import LKMunMehCardForm from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardForm.vue'
import LKMunMehCardHeader from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardHeader.vue'

export default {
  name: 'LKMunMehCard',
  components: {
    LKMunMehCardForm, LKMunMehCardHeader,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/components/Card/_BaseCard.scss";

.LKMunMehCard {
  @include _BaseCard;
}
</style>
